import { getGtmCode, defineIsTurboApp, getYandexMetricsCode, getYandexMetricsOptionsFromSravniTMOptions, defineSravniTM, defineGoogleClientId, defineABVariant, getGtmOptionsFromSravniTMOptions } from './helpers/index.js';
import { parseMainLocation } from './parseMainLocationUrl.js';

/**
 * Initialize analytic scripts
 * @param {IGTMOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initGTM({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
const initGTM = (options) => {
    const { id = 'GTM-PMDFG9', userId, theme, push: pushOptions, isWebview, fullURL, wl, abTestingStatistics } = options;
    const toPush = [
        {
            isWebview: !!isWebview,
        },
    ];
    if (userId) {
        toPush.push({ SravniUserId: userId });
    }
    if (theme) {
        toPush.push({ theme });
    }
    if (pushOptions && Array.isArray(pushOptions)) {
        toPush.push(...pushOptions);
    }
    if (fullURL && !wl) {
        toPush.push({ fullURL });
        const parsedMainLocation = parseMainLocation(fullURL);
        if (parsedMainLocation) {
            toPush.push({ mainLocation: parsedMainLocation });
        }
    }
    if (wl) {
        const { wlLocation, partnerLocation, fullURL } = wl;
        toPush.push({ wlLocation }, { partnerLocation }, { fullURL });
    }
    if (abTestingStatistics) {
        toPush.push({ abTestingStatistics: abTestingStatistics.statistics });
        toPush.push({ analyticsId: abTestingStatistics.userId });
    }
    const response = [
        'window.dataLayer = window.dataLayer || [];',
        // TODO: deprecated
        // ...(ab ? [defineABVariant(ab, "dataLayer")] : []),
        ...toPush.map((item) => `window.dataLayer.push(${JSON.stringify(item)});`),
        getGtmCode(id),
    ];
    return response.join('');
};
/**
 * Initialize analytic scripts
 * @param {IYandexMetricsOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initYandexMetrics({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
const initYandexMetrics = (options, dataLayer) => {
    const { id, wl, abTestingStatistics, push: pushOptions, isWebview, userId, theme, webvisor, childIframe, defer, } = options;
    const toPush = [
        {
            isWebview: !!isWebview,
        },
    ];
    if (userId) {
        toPush.push({ SravniUserId: userId });
    }
    if (theme) {
        toPush.push({ theme });
    }
    if (pushOptions && Array.isArray(pushOptions)) {
        toPush.push(...pushOptions);
    }
    if (wl) {
        const { wlLocation, partnerLocation, fullURL } = wl;
        toPush.push({ wlLocation }, { partnerLocation }, { fullURL });
    }
    if (abTestingStatistics) {
        toPush.push({ abTestingStatistics: abTestingStatistics.statistics });
        toPush.push({ analyticsId: abTestingStatistics.userId });
    }
    const response = [
        defineIsTurboApp(dataLayer),
        // TODO: deprecated
        // ...(ab ? [defineABVariant(ab, dataLayer)] : []),
        ...toPush.map((item) => `window['${dataLayer}'].push(${JSON.stringify(item)});`),
        getYandexMetricsCode({ id, webvisor, childIframe, defer }),
    ];
    return response.join('');
};
/**
 * Initialize analytic scripts
 * @param {ISravniTMOptions} options
 * @example
 *
 * ```jsx
 * <script dangerouslySetInnerHTML={{ __html: initSravniTM({ ab: 'AB_HOME', userId: subId, }) }} />
 * ```
 */
const initSravniTM = (options) => {
    const gtmOptions = getGtmOptionsFromSravniTMOptions(options);
    const yandexMetricsOptions = getYandexMetricsOptionsFromSravniTMOptions(options);
    const dataLayer = 'sravniDataLayer';
    const googleDataLayer = 'dataLayer';
    const response = [
        `window['${dataLayer}'] = window['${dataLayer}'] || [];`,
        `window['${googleDataLayer}'] = window['${googleDataLayer}'] || [];`,
        defineSravniTM({
            dataLayer,
            googleDataLayer,
            yandexId: yandexMetricsOptions.id,
        }),
        initGTM(gtmOptions),
        defineGoogleClientId(dataLayer),
        initYandexMetrics(yandexMetricsOptions, dataLayer),
    ];
    return response.join('');
};
/**
 * @deprecated
 */
const defineDataLayer = defineABVariant;

export { defineDataLayer, initGTM, initSravniTM, initYandexMetrics };
//# sourceMappingURL=analytics.js.map
